var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 132.8 143.3",
    style: {
      enableBackground: "new 0 0 132.8 143.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.3,73.5c0,0.3-0.1,0.6-0.1,0.9v68.1c0,0.1,0,0.3-0.2,0.4c-0.2,0.1-0.4,0-0.5,0L0.3,110 c-0.2-0.1-0.3-0.3-0.3-0.4V41c0-0.1,0-0.3,0.2-0.4c0.2-0.1,0.4,0,0.5,0l21.4,11.3l0.3,38.7l7.7-4.8l7.7,12.4l1.1-37.4l0-0.1 l23.6,12.5C62.8,73.3,63,73.4,63.3,73.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133,41.2v66.1c0,0.6-0.3,1.1-0.8,1.4l-60.1,33.2c-0.7,0.4-1.3,0.2-1.6,0c-0.3-0.2-0.8-0.6-0.8-1.3V74.4 c0-0.6,0.3-1.1,0.8-1.3L130,40.2l0.6-0.3c0.3-0.2,0.5-0.2,0.8-0.2c0.3,0,0.6,0.1,0.8,0.2C132.5,40,133,40.4,133,41.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.7,12.6L28.8,47.9l-22.6-12c-0.8-0.4-0.9-1.1-0.9-1.4c0-0.3,0.1-1,0.8-1.4L65.8,0.2c0.5-0.3,1.1-0.3,1.6,0 L90.7,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.7,33.1c0,0.3-0.1,1-0.8,1.4L67.4,67.3c-0.3,0.2-0.7,0.4-1,0.6c-0.1-0.1-0.2-0.1-0.4-0.2L45.4,56.8 l0.1-0.1l61.3-35.6l20,10.6C127.6,32.1,127.7,32.8,127.7,33.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/Product.dc469636a111288178227690aba3a448.svg";
export { ForwardRef as ReactComponent };